import { StyleSheet } from "react-native";
const styles = StyleSheet.create({
  container: {
    width: "33.3333%",
    aspectRatio: 1,
    backgroundColor: "gray",
  },
  image: {
    width: "100%",
    height: "100%",
    resizeMode: "cover",
  },
});

export default styles;
